import { getArrayOfCollectionIconsWithTitle } from "icons/helpers";

export const handleContainerType = ({ type, STYLE_TYPES }) => {
    switch (type) {
        case "primary":
            return STYLE_TYPES.PRIMARY;
        case "secondary":
            return STYLE_TYPES.SECONDARY;
        case "darkMode":
            return STYLE_TYPES.DARKMODE;
        default:
            return STYLE_TYPES.PRIMARY;
    }
};

export const getImageHoverStyle = ({
    type,
    isPhoto,
    defaultHover,
    photoHover,
    iconHover
}) => {
    const darkModeName = "darkMode";

    if (type !== darkModeName && isPhoto) {
        return defaultHover, photoHover;
    } else if (type !== darkModeName && !isPhoto) {
        return iconHover;
    } else if (type === darkModeName && isPhoto) {
        return defaultHover, photoHover;
    } else if (type === darkModeName && !isPhoto) {
        return; // intentionally left empty - when type is darkMode, we dont affect the image
    } else {
        return defaultHover;
    }
};

export const getArrayOfIcons = ({ collection }) => {
    /*************
     *
     * NOTE:
     *
     * When the shape of the collection icons changes,
     * we will have to update this function to return
     * the correct array of urls
     *
     */

    let iconPaths = [];

    collection.icons.map(icon => {
        iconPaths.push(icon.preview_url_84);
    });

    return iconPaths;
};

export const formatCollections = ({ arrayOfCollectionObjects }) => {
    return arrayOfCollectionObjects.map(collection => {
        return {
            title: collection.name,
            url: collection.url,
            imageSrcAndTitle: getArrayOfCollectionIconsWithTitle({
                icons: collection.icons.items
            }),
            type: "secondary",
            usePlaceholder: true,
            subtitle: collection.icons.totalCount + " icons"
        };
    });
};
